import {configureStore} from '@reduxjs/toolkit';
import updateTableSlice from './update-table-slice';
import authSlice from './auth-slice';

const store = configureStore({
    reducer: {updateTable: updateTableSlice.reducer, auth: authSlice.reducer}
});

export default store;